import { orderBy, toLower, toUpper } from "lodash";
import Product from "../models/Product";
import { isListNotEmpty, isObjectNotEmpty, isStringNotEmpty } from "./objectUtils";
import { toFirstNameLastName } from "./stringFormatter";
import Variant from "../models/Variant";
import { getOfferGroupByToken as getOfferGroupByTokenResolver } from "./productIdentityUtils";
import { getCommercialEquivalencyGroupById as getCommercialEquivalencyGroupByIdResolver } from "./commercialEquivalencyUtils";
import { getFunnelChoiceSetById as getFunnelChoiceSetByIdResolver } from "./funnelChoiceSetUtils";

export const getCoveredEntityUserInfo = (coveredEntityId, userId, coveredEntityUsers) => {
	return isListNotEmpty(coveredEntityUsers) && isStringNotEmpty(coveredEntityId) && isStringNotEmpty(userId) && coveredEntityUsers.some(i => i.coveredEntityId === coveredEntityId && i.userId === userId) ? coveredEntityUsers.find(i => i.coveredEntityId === coveredEntityId && i.userId === userId) : null;
};

export const getCoveredEntityInfo = (coveredEntityId, coveredEntities) => {
	return isListNotEmpty(coveredEntities) && isStringNotEmpty(coveredEntityId) && coveredEntities.some(i => i.id === coveredEntityId) ? coveredEntities.find(i => i.id === coveredEntityId) : null;
};

export const getCoveredEntityName = (coveredEntityId, coveredEntities) => {
	return isListNotEmpty(coveredEntities) && isStringNotEmpty(coveredEntityId) && coveredEntities.some(i => i.id === coveredEntityId) ? coveredEntities.find(i => i.id === coveredEntityId)?.name : '';
};

export const getCoveredEntityBySlug = (slug, coveredEntities) => {
	return isListNotEmpty(coveredEntities) && isStringNotEmpty(slug) && coveredEntities.some(i => i.slug === slug) ? coveredEntities.find(i => i.slug === slug) : null;
};

export const getUserInfo = (userId, users) => {
	return isListNotEmpty(users) && isStringNotEmpty(userId) && users.some(i => i.userId === userId) ? users.find(i => i.userId === userId) : null;
};

export const getUserDisplayName = (userId, users) => {
	return isListNotEmpty(users) && isStringNotEmpty(userId) && users.some(i => i.userId === userId) ? toFirstNameLastName(users.find(r => r.userId === userId)) : '';
};

export const getFileInfo = (fileRefId, files) => {
	return isListNotEmpty(files) && isStringNotEmpty(fileRefId) && files.some(i => i.fileRefId === fileRefId) ? files.find(t => t.fileRefId === fileRefId)?.fileUrl : null;
};

export const getProductById = (productId, products) => {
	return isListNotEmpty(products) && isStringNotEmpty(productId) && products.some(i => i.id === productId) ? products.find(i => i.id === productId) : null;
};

export const getProductObjById = (productId, products) => {
	let product = isListNotEmpty(products) && isStringNotEmpty(productId) && products.some(i => i.id === productId) ? products.find(i => i.id === productId) : null;
	if (isObjectNotEmpty(product)) {
		return new Product(product);
	} else {
		return null;
	}
};

export const getProductInfo = (productId, products) => {
	return isListNotEmpty(products) && isStringNotEmpty(productId) && products.some(i => i.id === productId) ? products.find(i => i.id === productId) : null;
};

export const getProductBySlug = (slug, products) => {
	return isListNotEmpty(products) && isStringNotEmpty(slug) && products.some(i => i.slug === slug) ? products.find(i => i.slug === slug) : null;
};

export const getProductBySku = (sku, products) => {
	return isListNotEmpty(products) && isStringNotEmpty(sku) && products.some(i => i.sku === sku) ? products.find(i => i.sku === sku) : null;
};

export const getProductByShortSku = (shortSku, products) => {
	return isListNotEmpty(products) && isStringNotEmpty(shortSku) && products.some(i => i.shortSku === toUpper(shortSku)) ? products.find(i => i.shortSku === toUpper(shortSku)) : null;
};

export const getProductFamilyById = (id, productFamilies) => {
	return isListNotEmpty(productFamilies) && isStringNotEmpty(id) && productFamilies.some(i => i.id === id) ? productFamilies.find(i => i.id === id) : null;
};

export const getOfferGroupById = (id, offerGroups) => {
	return isListNotEmpty(offerGroups) && isStringNotEmpty(id) && offerGroups.some(i => i.id === id) ? offerGroups.find(i => i.id === id) : null;
};

export const getOfferGroupByToken = (token, offerGroups) => {
	return getOfferGroupByTokenResolver(token, offerGroups);
};

export const getCommercialEquivalencyGroupById = (id, commercialEquivalencyGroups) => {
	return getCommercialEquivalencyGroupByIdResolver(id, commercialEquivalencyGroups);
};

export const getFunnelChoiceSetById = (id, funnelChoiceSets) => {
	return getFunnelChoiceSetByIdResolver(id, funnelChoiceSets);
};

export const getProductSkuById = (id, products) => {
	return isListNotEmpty(products) && isStringNotEmpty(id) && products.some(i => i.id === id) ? products.find(i => i.id === id)?.sku : '';
};

export const getProductNameById = (id, products) => {
	return isListNotEmpty(products) && isStringNotEmpty(id) && products.some(i => i.id === id) ? products.find(i => i.id === id)?.name : '';
};

export const getProductNameBySku = (sku, products) => {
	return isListNotEmpty(products) && isStringNotEmpty(sku) && products.some(i => i.sku === sku) ? products.find(i => i.sku === sku)?.name : '';
};

export const getProductNameByShortSku = (shortSku, products) => {
	return isListNotEmpty(products) && isStringNotEmpty(shortSku) && products.some(i => i.shortSku === shortSku) ? products.find(i => i.shortSku === shortSku)?.name : '';
};

export const getProductCategoryById = (id, productCategories) => {
	return isListNotEmpty(productCategories) && isStringNotEmpty(id) && productCategories.some(i => i.id === id) ? productCategories.find(i => i.id === id) : null;
};

export const getProductCategoryBySlug = (slug, productCategories) => {
	return isListNotEmpty(productCategories) && isStringNotEmpty(slug) && productCategories.some(i => i.slug === slug) ? productCategories.find(i => i.slug === slug) : null;
};

export const getProductCategoriesBySlugs = (slugs, productCategories) => {
	return isListNotEmpty(productCategories) && isListNotEmpty(slugs) && productCategories.some(i => slugs.includes(i.slug)) ? productCategories.filter(i => slugs.includes(i.slug)) : [];
};

export const getChildProductCategoriesByParentId = (parentId, productCategories) => {
	return isListNotEmpty(productCategories) && isStringNotEmpty(parentId) && productCategories.some(i => i.parentId === parentId) ? productCategories.filter(i => i.parentId === parentId) : [];
};

export const getProductsByCategoryId = (categoryId, products) => {
	return isListNotEmpty(products) && isStringNotEmpty(categoryId) ? products.filter(i => i.categoryIds.includes(categoryId)) : [];
};

export const getProductsByCategorySlug = (categorySlug, products, productCategories) => {
	if (isListNotEmpty(products) && isListNotEmpty(productCategories) && isStringNotEmpty(categorySlug)) {
		let productCategory = getProductCategoryBySlug(categorySlug, productCategories);
		if (isObjectNotEmpty(productCategory)) {
			return products.filter(i => i.categoryIds.includes(productCategory.id));
		}
	}

	return [];
};

export const getProductCategoriesByProductId = (productId, products, productCategories) => {
	if (isListNotEmpty(products) && isListNotEmpty(productCategories) && isStringNotEmpty(productId)) {
		let product = products.find(i => i.id === productId);
		if (isObjectNotEmpty(product)) {
			return productCategories.filter(i => product.categoryIds.includes(i.id));
		}
	}

	return [];
};

export const getAgreementByKey = (key, agreements) => {
	return isListNotEmpty(agreements) && isStringNotEmpty(key) && agreements.some(i => i.key === key) ? agreements.find(i => i.key === key) : null;
};

export const getAgreementNameByKey = (key, agreements) => {
	return isListNotEmpty(agreements) && isStringNotEmpty(key) && agreements.some(i => i.key === key) ? agreements.find(i => i.key === key)?.name : '';
};

// resolves a survey BY ID - consult/follow-up pages call this with the surveyId recorded on a
// historical encounter, which may be a deactivated older version, so the orchestrator must keep
// inactive surveys loaded (see getSurveys)
export const getSurveyInfo = (surveyId, surveys) => {
	return isListNotEmpty(surveys) && isStringNotEmpty(surveyId) && surveys.some(i => i.id === surveyId) ? surveys.find(i => i.id === surveyId) : null;
};

export const getSurveyBySlug = (slug, surveys) => {
	return isListNotEmpty(surveys) && isStringNotEmpty(slug) && surveys.some(i => i.slug === slug) ? surveys.find(i => i.slug === slug) : null;
};

export const getSurveyNameById = (surveyId, surveys) => {
	return isListNotEmpty(surveys) && isStringNotEmpty(surveyId) && surveys.some(i => i.id === surveyId) ? surveys.find(i => i.id === surveyId)?.name : '';
};

export const getSurveyQuestionsById = (surveyId, surveys) => {
	return isListNotEmpty(surveys) && isStringNotEmpty(surveyId) && surveys.some(i => i.id === surveyId) ? surveys.find(i => i.id === surveyId)?.questions : [];
};

const buildSurveyList = (surveyItems = [], surveys = []) => {
	return orderBy(
		surveyItems.filter((surveyItem) => surveyItem.enabled !== false),
		['displayOrder'],
		['asc']
	).map((survey, index) => {
		return {
			...survey,
			displayOrder: survey.displayOrder ?? index + 1,
			questions: surveys.find(i => i.id === survey.surveyId)?.questions ?? []
		};
	});
};

export const getSurveysByProductSku = (productSku, products, surveys) => {
	if (isListNotEmpty(surveys) && isListNotEmpty(products) && isStringNotEmpty(productSku)) {
		let product = getProductBySku(productSku, products);
		if (isObjectNotEmpty(product) && isListNotEmpty(product.surveys)) {
			return buildSurveyList(product.surveys, surveys);
		}
	}

	return [];
};

export const getSurveysByCampaignId = (campaignId, campaigns, surveys) => {
	if (isListNotEmpty(surveys) && isListNotEmpty(campaigns) && isStringNotEmpty(campaignId)) {
		let campaign = getCampaignById(campaignId, campaigns);
		if (isObjectNotEmpty(campaign) && isListNotEmpty(campaign.surveys)) {
			return campaign.surveys.map((survey, index) => {
				return {
					...survey,
					displayOrder: index + 1,
					questions: surveys.find(i => i.id === survey.surveyId)?.questions ?? []
				};
			});
		}
	}

	return [];
};

export const getSurveysByCampaignSlug = (campaignSlug, campaigns, surveys) => {
	if (isListNotEmpty(surveys) && isListNotEmpty(campaigns) && isStringNotEmpty(campaignSlug)) {
		let campaign = getCampaignBySlug(campaignSlug, campaigns);
		if (isObjectNotEmpty(campaign) && isListNotEmpty(campaign.surveys)) {
			return campaign.surveys.map((survey, index) => {
				return {
					...survey,
					displayOrder: index + 1,
					questions: surveys.find(i => i.id === survey.surveyId)?.questions ?? []
				};
			});
		}
	}

	return [];
};

export const getSurveysByProgramId = (programId, programs, surveys) => {
	if (isListNotEmpty(surveys) && isListNotEmpty(programs) && isStringNotEmpty(programId)) {
		let program = getProgramById(programId, programs);
		if (isObjectNotEmpty(program) && isListNotEmpty(program.surveys)) {
			return buildSurveyList(program.surveys, surveys);
		}
	}

	return [];
};

export const getSurveysByProgramSlug = (programSlug, programs, surveys) => {
	if (isListNotEmpty(surveys) && isListNotEmpty(programs) && isStringNotEmpty(programSlug)) {
		let program = getProgramBySlug(programSlug, programs);
		if (isObjectNotEmpty(program) && isListNotEmpty(program.surveys)) {
			return buildSurveyList(program.surveys, surveys);
		}
	}

	return [];
};

export const getConditionInfo = (conditionId, conditions) => {
	return isListNotEmpty(conditions) && isStringNotEmpty(conditionId) && conditions.some(i => i.id === conditionId) ? conditions.find(i => i.id === conditionId) : null;
};

export const getConditionName = (conditionId, conditions) => {
	return isListNotEmpty(conditions) && isStringNotEmpty(conditionId) && conditions.some(i => i.id === conditionId) ? conditions.find(i => i.id === conditionId)?.name : '';
};

export const getVaccinationInfo = (vaccinationId, vaccinations) => {
	return isListNotEmpty(vaccinations) && isStringNotEmpty(vaccinationId) && vaccinations.some(i => i.id === vaccinationId) ? vaccinations.find(i => i.id === vaccinationId) : null;
};

export const getVaccinationName = (vaccinationId, vaccinations) => {
	return isListNotEmpty(vaccinations) && isStringNotEmpty(vaccinationId) && vaccinations.some(i => i.id === vaccinationId) ? vaccinations.find(i => i.id === vaccinationId)?.name : '';
};

export const getTestInfo = (testId, tests) => {
	return isListNotEmpty(tests) && isStringNotEmpty(testId) && tests.some(i => i.id === testId) ? tests.find(i => i.id === testId) : null;
};

export const getTestName = (testId, tests) => {
	return isListNotEmpty(tests) && isStringNotEmpty(testId) && tests.some(i => i.id === testId) ? tests.find(i => i.id === testId)?.name : '';
};

export const getBiomarkerInfo = (biomarkerId, biomarkers) => {
	return isListNotEmpty(biomarkers) && isStringNotEmpty(biomarkerId) && biomarkers.some(i => i.id === biomarkerId) ? biomarkers.find(i => i.id === biomarkerId) : null;
};

export const getBiomarkerName = (biomarkerId, biomarkers) => {
	return isListNotEmpty(biomarkers) && isStringNotEmpty(biomarkerId) && biomarkers.some(i => i.id === biomarkerId) ? biomarkers.find(i => i.id === biomarkerId)?.name : '';
};

// DEPRECATED: Use getBiomarkerInfo instead
export const getMetricInfo = getBiomarkerInfo;
// DEPRECATED: Use getBiomarkerName instead
export const getMetricName = getBiomarkerName;

export const getCampaignById = (id, campaigns) => {
	return isListNotEmpty(campaigns) && isStringNotEmpty(id) && campaigns.some(i => i.id === id) ? campaigns.find(i => i.id === id) : null;
};

export const getCampaignBySlug = (slug, campaigns) => {
	return isListNotEmpty(campaigns) && isStringNotEmpty(slug) && campaigns.some(i => i.slug === slug) ? campaigns.find(i => i.slug === slug) : null;
};

export const getCampaignByProgramSlug = (programSlug, campaigns, programs) => {
	let program = getProgramBySlug(programSlug, programs);
	if (isObjectNotEmpty(program) && isStringNotEmpty(program.defaultCampaignId)) {
		return getCampaignById(program.defaultCampaignId, campaigns);
	}

	return isListNotEmpty(campaigns) && isStringNotEmpty(program?.id) && campaigns.some(i => i.programId === program?.id) ? campaigns.find(i => i.programId === program?.id) : null;
};

export const getDefaultCampaign = (programSlug, campaignSlug, campaigns, programs) => {
	if (isStringNotEmpty(campaignSlug)) {
		return getCampaignBySlug(campaignSlug, campaigns);
	}

	let program = getProgramBySlug(programSlug, programs);
	if (isObjectNotEmpty(program) && isStringNotEmpty(program.defaultCampaignId)) {
		return getCampaignById(program.defaultCampaignId, campaigns);
	}

	return isListNotEmpty(campaigns) && isStringNotEmpty(program?.id) && campaigns.some(i => i.programId === program?.id) ? campaigns.find(i => i.programId === program?.id) : null;
};

export const getDefaultProduct = (programSlug, productSku, products, programs) => {
	if (isStringNotEmpty(productSku)) {
		return getProductBySku(productSku, products);
	}

	let program = getProgramBySlug(programSlug, programs);
	if (isObjectNotEmpty(program) && isListNotEmpty(program.productIds)) {
		let unorderedProducts = products.filter(i => program.productIds.includes(i.id));
		let orderedProducts = orderBy(unorderedProducts, ['displayOrder'], ['asc']);
		return getProductInfo(orderedProducts?.[0]?.id, products);
	}

	return null;
};

export const getDefaultProgramByProductSku = (productSku, products, programs) => {
	let product = getProductBySku(productSku, products);
	if (isObjectNotEmpty(product) && isStringNotEmpty(product?.id)) {
		let unorderedPrograms = programs.filter(i => i.productIds.includes(product?.id));
		return isListNotEmpty(unorderedPrograms) ? unorderedPrograms?.[0] : null;
	}

	return null;
};

export const getProductsByProgramId = (programId, products, programs) => {
	let program = getProgramById(programId, programs);
	if (isObjectNotEmpty(program) && isListNotEmpty(program.productIds)) {
		return products.filter(i => program.productIds.includes(i.id));
	}

	return [];
};

export const getProductsByProgramIds = (programIds, products, programs) => {
	let matchingPrograms = getProgramsByIds(programIds, programs) ?? [];
	let matchingProductIds = [...new Set(matchingPrograms.flatMap(i => i.productIds ?? []))];
	if (isListNotEmpty(matchingPrograms) && isListNotEmpty(matchingProductIds)) {
		return products.filter(i => matchingProductIds.includes(i.id));
	}

	return [];
};

export const getProductsByProgramSlug = (programSlug, products, programs) => {
	let program = getProgramBySlug(programSlug, programs);
	if (isObjectNotEmpty(program) && isListNotEmpty(program.productIds)) {
		return products.filter(i => program.productIds.includes(i.id));
	}

	return [];
};

export const getProductsByProgramSlugs = (programSlugs, products, programs) => {
	let matchingPrograms = getProgramsBySlugs(programSlugs, programs) ?? [];
	let matchingProductIds = [...new Set(matchingPrograms.flatMap(i => i.productIds ?? []))];
	if (isListNotEmpty(matchingPrograms) && isListNotEmpty(matchingProductIds)) {
		return products.filter(i => matchingProductIds.includes(i.id));
	}

	return [];
};

export const getProgramById = (id, programs) => {
	return isListNotEmpty(programs) && isStringNotEmpty(id) && programs.some(i => i.id === id) ? programs.find(i => i.id === id) : null;
};

export const getProgramsByIds = (ids, programs) => {
	return isListNotEmpty(programs) && isListNotEmpty(ids) && programs.some(i => ids.includes(i.id)) ? programs.filter(i => ids.includes(i.id)) : [];
};

export const getProgramNameById = (id, programs) => {
	return isListNotEmpty(programs) && isStringNotEmpty(id) && programs.some(i => i.id === id) ? programs.find(i => i.id === id)?.name : '';
};

export const getProgramSlugById = (id, programs) => {
	return isListNotEmpty(programs) && isStringNotEmpty(id) && programs.some(i => i.id === id) ? programs.find(i => i.id === id)?.slug : '';
};

export const getProgramBySlug = (slug, programs) => {
	return isListNotEmpty(programs) && isStringNotEmpty(slug) && programs.some(i => i.slug === slug) ? programs.find(i => i.slug === slug) : null;
};

export const getProgramsBySlugs = (slugs, programs) => {
	return isListNotEmpty(programs) && isListNotEmpty(slugs) && programs.some(i => slugs.includes(i.slug)) ? programs.filter(i => slugs.includes(i.slug)) : [];
};

export const getProgramNameBySlug = (slug, programs) => {
	return isListNotEmpty(programs) && isStringNotEmpty(slug) && programs.some(i => i.slug === slug) ? programs.find(i => i.slug === slug)?.name : '';
};

export const getAffiliateById = (id, affiliates) => {
	return isListNotEmpty(affiliates) && isStringNotEmpty(id) && affiliates.some(i => i.id === id) ? affiliates.find(i => i.id === id) : null;
};

export const getPartnerById = (id, partners) => {
	return isListNotEmpty(partners) && isStringNotEmpty(id) && partners.some(i => i.id === id) ? partners.find(i => i.id === id) : null;
};

export const getVariantsByProductId = (productId, variants) => {
	return isListNotEmpty(variants) && isStringNotEmpty(productId) ? variants.filter(i => i.productId === productId) : [];
};

export const getVariantsByProductSlug = (productSlug, variants, products) => {
	if (isListNotEmpty(variants) && isListNotEmpty(products) && isStringNotEmpty(productSlug)) {
		let product = getProductBySlug(productSlug, products);
		if (isObjectNotEmpty(product)) {
			return variants.filter(i => i.productId === product?.id);
		}
	}

	return [];
};

export const getVariantsByProductSku = (productSku, variants, products) => {
	if (isListNotEmpty(variants) && isListNotEmpty(products) && isStringNotEmpty(productSku)) {
		let product = getProductBySku(productSku, products);
		if (isObjectNotEmpty(product)) {
			return variants.filter(i => i.productId === product?.id);
		}
	}

	return [];
};

export const getVariantById = (variantId, variants) => {
	return isListNotEmpty(variants) && isStringNotEmpty(variantId) && variants.some(i => i.id === variantId) ? variants.find(i => i.id === variantId) : null;
};

export const getVariantObjById = (variantId, variants) => {
	let variant = isListNotEmpty(variants) && isStringNotEmpty(variantId) && variants.some(i => i.id === variantId) ? variants.find(i => i.id === variantId) : null;
	if (isObjectNotEmpty(variant)) {
		return new Variant(variant);
	} else {
		return null;
	}
};

export const getVariantNameById = (variantId, variants) => {
	return isListNotEmpty(variants) && isStringNotEmpty(variantId) && variants.some(i => i.id === variantId) ? variants.find(i => i.id === variantId)?.name : '';
};

export const getVariantSkuById = (variantId, variants) => {
	return isListNotEmpty(variants) && isStringNotEmpty(variantId) && variants.some(i => i.id === variantId) ? variants.find(i => i.id === variantId)?.sku : '';
};

export const getVariantBySlug = (slug, variants) => {
	return isListNotEmpty(variants) && isStringNotEmpty(slug) && variants.some(i => i.slug === slug) ? variants.find(i => i.slug === slug) : null;
};

export const getVariantBySku = (sku, variants) => {
	return isListNotEmpty(variants) && isStringNotEmpty(sku) && variants.some(i => i.sku === sku) ? variants.find(i => i.sku === sku) : null;
};

export const getShippingMethodById = (shippingMethodId, shippingMethods) => {
	return isListNotEmpty(shippingMethods) && isStringNotEmpty(shippingMethodId) && shippingMethods.some(i => i.id === shippingMethodId) ? shippingMethods.find(i => i.id === shippingMethodId) : null;
};

export const getProviderByUserId = (userId, providers) => {
	return isListNotEmpty(providers) && isStringNotEmpty(userId) && providers.some(i => i.userId === userId) ? providers.find(i => i.userId === userId) : null;
};

export const getRepByUserId = (repId, reps) => {
	if (isStringNotEmpty(repId) && isListNotEmpty(reps)) {
		let rep = reps.find(t => t.userId === repId);
		if (isObjectNotEmpty(rep)) {
			return rep;
		}
	}

	return null;
};

export const getRepDisplayName = (repId, reps) => {
	return isListNotEmpty(reps) && isStringNotEmpty(repId) && repId !== 'NONE' ? toFirstNameLastName(reps.find(r => r.userId === repId)) : '';
};







export const getArticleById = (articleId, articles) => {
	return isListNotEmpty(articles) && isStringNotEmpty(articleId) && articles.some(i => i.id === articleId) ? articles.find(i => i.id === articleId) : null;
};

export const getArticleBySlug = (slug, articles) => {
	return isListNotEmpty(articles) && isStringNotEmpty(slug) && articles.some(i => i.slug === slug) ? articles.find(i => i.slug === slug) : null;
};

export const getArticleCategoryById = (id, articleCategories) => {
	return isListNotEmpty(articleCategories) && isStringNotEmpty(id) && articleCategories.some(i => i.id === id) ? articleCategories.find(i => i.id === id) : null;
};

export const getArticleCategoryBySlug = (slug, articleCategories) => {
	return isListNotEmpty(articleCategories) && isStringNotEmpty(slug) && articleCategories.some(i => i.slug === slug) ? articleCategories.find(i => i.slug === slug) : null;
};

export const getChildArticleCategoriesByParentId = (parentId, articleCategories) => {
	return isListNotEmpty(articleCategories) && isStringNotEmpty(parentId) && articleCategories.some(i => i.parentId === parentId) ? articleCategories.filter(i => i.parentId === parentId) : [];
};

export const getArticlesByCategoryId = (categoryId, articles) => {
	return isListNotEmpty(articles) && isStringNotEmpty(categoryId) ? articles.filter(i => i.categoryId === categoryId) : [];
};

export const getArticlesByCategorySlug = (categorySlug, articles, articleCategories) => {
	if (isListNotEmpty(articles) && isListNotEmpty(articleCategories) && isStringNotEmpty(categorySlug)) {
		let articleCategory = getProductCategoryBySlug(categorySlug, articleCategories);
		if (isObjectNotEmpty(articleCategory)) {
			return articles.filter(i => i.categoryId === articleCategory.id);
		}
	}

	return [];
};

export const getArticleCategoryByArticleId = (articleId, articles, articleCategories) => {
	if (isListNotEmpty(articles) && isListNotEmpty(articleCategories) && isStringNotEmpty(articleId)) {
		let article = articles.find(i => i.id === articleId);
		if (isObjectNotEmpty(article)) {
			return articleCategories.find(i => article.categoryId === i.id);
		}
	}

	return null;
};

export const getAffiliateUserInfo = (affiliateId, userId, affiliateUsers) => {
	return isListNotEmpty(affiliateUsers) && isStringNotEmpty(affiliateId) && isStringNotEmpty(userId) && affiliateUsers.some(i => i.affiliateId === affiliateId && i.userId === userId) ? affiliateUsers.find(i => i.affiliateId === affiliateId && i.userId === userId) : null;
};

export const getAffiliateInfo = (affiliateId, affiliates) => {
	return isListNotEmpty(affiliates) && isStringNotEmpty(affiliateId) && affiliates.some(i => i.id === affiliateId) ? affiliates.find(i => i.id === affiliateId) : null;
};

export const getAffiliateName = (affiliateId, affiliates) => {
	return isListNotEmpty(affiliates) && isStringNotEmpty(affiliateId) && affiliates.some(i => i.id === affiliateId) ? affiliates.find(i => i.id === affiliateId)?.name : '';
};

export const getEventById = (eventId, events) => {
	return isListNotEmpty(events) && isStringNotEmpty(eventId) && events.some(i => i.id === eventId) ? events.find(i => i.id === eventId) : null;
};

export const getCommunityById = (communityId, communities) => {
	return isListNotEmpty(communities) && isStringNotEmpty(communityId) && communities.some(i => i.id === communityId) ? communities.find(i => i.id === communityId) : null;
};

export const getCommunityBySlug = (slug, communities) => {
	return isListNotEmpty(communities) && isStringNotEmpty(slug) && communities.some(i => i.slug === slug) ? communities.find(i => i.slug === toLower(slug)) : null;
};

export const getPartnerUserInfo = (partnerId, userId, partnerUsers) => {
	return isListNotEmpty(partnerUsers) && isStringNotEmpty(partnerId) && isStringNotEmpty(userId) && partnerUsers.some(i => i.partnerId === partnerId && i.userId === userId) ? partnerUsers.find(i => i.partnerId === partnerId && i.userId === userId) : null;
};

export const getPartnerInfo = (partnerId, partners) => {
	return isListNotEmpty(partners) && isStringNotEmpty(partnerId) && partners.some(i => i.id === partnerId) ? partners.find(i => i.id === partnerId) : null;
};

export const getPartnerName = (partnerId, partners) => {
	return isListNotEmpty(partners) && isStringNotEmpty(partnerId) && partners.some(i => i.id === partnerId) ? partners.find(i => i.id === partnerId)?.name : '';
};
